import { render, staticRenderFns } from "./seriesCatButton.vue?vue&type=template&id=06e383bf&"
import script from "./seriesCatButton.vue?vue&type=script&lang=js&"
export * from "./seriesCatButton.vue?vue&type=script&lang=js&"
import style0 from "./seriesCatButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports